// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  WindowTimebase,
  TransformWindowPoint,
} from "./types";

export const params = {
  streamIds: __t.array(__t.u64()),
  streamNames: __t.array(__t.string()),
  startMicros: __t.i64(),
  endMicros: __t.i64(),
  samples: __t.u32(),
  get timebase() {
    return WindowTimebase;
  },
};
export const returnType = __t.array(TransformWindowPoint)